<section class="container mobiledb-Container mb-5">
  <section class="row pt-3">
    <!-- ===================Left Part====================== -->
    <section class="col-3">
      <ng-container *ngIf="isPharmacy$ | async">
        <section class="mb-5" *ngIf="orderHistory$ | async as orderHistory">
          <p class="font-bold influenza-contact-section__title">
            {{ 'flu.dashboard.order-status' | cxTranslate }}
          </p>
          <div class="order-status-list">
            <div
              class="d-flex justify-content-between pb-2 border-bottom mb-2"
              *ngFor="let order of orderHistory">
              <span>{{ order.guid }}</span>
              <a class="c-link pr-2" (click)="setGraph(order.guid)">{{
                'flu.dashboard.view' | cxTranslate
              }}</a>
            </div>
          </div>
        </section>
      </ng-container>

      <section class="influenza-contact-section">
        <div class="influenza-contact-section__header">
          <section class="influenza-contact-section__title">
            {{ 'flu.dashboard.influenzaContact' | cxTranslate }}
          </section>
        </div>
        <!--edit is not clicked-->
        <ng-container *ngIf="!editClicked">
          <section
            class="infcontact-Container"
            *ngIf="infContacts$ | async as infContacts">
            <section class="res-contact">
              <ul *ngFor="let con of infContacts" class="no-Bullets">
                <li>
                  <section class="inf-Contact-Desc">
                    {{ 'flu.dashboard.contactMsg' | cxTranslate }}
                  </section>
                </li>
                <li *ngIf="isPharmacy$ | async">
                  <p class="displayCell">
                    {{ 'flu.dashboard.fluContactId' | cxTranslate }}
                  </p>
                  <span class="align-Top displayCell">{{
                    con.fluContactId
                  }}</span>
                </li>
                <li>
                  <p class="displayCell">
                    {{ 'selectVaccines.name' | cxTranslate }}
                  </p>
                  <span class="align-Top displayCell" *ngIf="con.firstName">
                    {{ con.firstName }} {{ con.lastName ? con.lastName : '' }}
                  </span>
                </li>
                <li>
                  <a
                    href="{{ 'mailto:' + con?.email }}"
                    class="c-link d-flex gap-1">
                    <i class="fa fa-envelope"></i
                    ><span class="c-link">{{ con.email }}</span></a
                  >

                  <a
                    href="{{ 'tel:' + con?.phoneNo }}"
                    class="c-link d-flex gap-1">
                    <i class="fa fa-phone"></i
                    ><span class="align-Top prefer-Value">{{
                      con.phoneNo
                    }}</span></a
                  >
                </li>
                <hr />
              </ul>
            </section>
            <section
              *ngIf="missingContact"
              class="missing-contact-message mb-1">
              {{ 'selectVaccines.messageMissingContact' | cxTranslate }}
            </section>
          </section>
          <section *ngIf="!(infContacts$ | async)">
            <button
              *ngIf="!userData.selectedAccounts?.length"
              type="button"
              class="c-button c-button--secondary"
              (click)="editContact()">
              {{ 'flu.dashboard.addContact' | cxTranslate }}
            </button>
            <span class="text-Contact" *ngIf="reserveNowClicked">{{
              'selectVaccines.add_Contact_Err' | cxTranslate
            }}</span>
          </section>
        </ng-container>
        <!--edit is clicked-->

        <section
          class="edit-form__container"
          *ngIf="editClicked"
          [formGroup]="editForm">
          <section class="">
            <label class="edit-labels">{{
              'form.fields.firstName' | cxTranslate
            }}</label>
          </section>
          <section class="c-text-input">
            <input
              class="form-control input-Field-Styling"
              type="text"
              formControlName="firstName"
              maxlength="255"
              [ngClass]="{
                requiredField:
                  editForm.get('firstName').invalid &&
                  (editForm.get('firstName').touched ||
                    editForm.get('firstName').dirty),
              }" />
            <span
              class="text-error"
              *ngIf="
                !editForm.get('firstName').value &&
                editForm.get('firstName').touched
              "
              >{{ 'form.errors.required' | cxTranslate }}</span
            >
            <span
              class="text-danger"
              *ngIf="
                editForm.get('firstName').value &&
                editForm.get('firstName').invalid &&
                (editForm.get('firstName').touched ||
                  editForm.get('firstName').dirty)
              "
              >{{ 'form.errors.invalid' | cxTranslate }}</span
            >
          </section>
          <section class="">
            <label class="edit-labels">{{
              'form.fields.lastName' | cxTranslate
            }}</label>
          </section>
          <section class="c-text-input">
            <input
              class="form-control input-Field-Styling"
              type="text"
              formControlName="lastName"
              maxlength="255"
              [ngClass]="{
                requiredField:
                  editForm.get('lastName').invalid &&
                  (editForm.get('lastName').touched ||
                    editForm.get('lastName').dirty),
              }" />
            <span
              class="text-error"
              *ngIf="
                !editForm.get('lastName').value &&
                editForm.get('lastName').touched
              "
              >{{ 'form.errors.required' | cxTranslate }}</span
            >
            <span
              class="text-danger"
              *ngIf="
                editForm.get('lastName').value &&
                editForm.get('lastName').invalid &&
                (editForm.get('lastName').touched ||
                  editForm.get('lastName').dirty)
              "
              >{{ 'form.errors.invalid' | cxTranslate }}</span
            >
          </section>
          <section class="">
            <label for="email" class="edit-email edit-labels">{{
              'form.fields.email' | cxTranslate
            }}</label>
          </section>
          <section class="c-text-input">
            <input
              class="form-control contact-Field input-Field-Styling"
              type="email"
              formControlName="email"
              maxlength="241"
              [ngClass]="{
                requiredField:
                  editForm.get('email').invalid &&
                  (editForm.get('email').touched ||
                    editForm.get('email').dirty),
              }" />
          </section>
          <span
            class="text-error"
            *ngIf="
              editForm.get('email').invalid &&
              (editForm.get('email').dirty || editForm.get('email').touched) &&
              editForm.get('email').value
            ">
            {{ 'form.errors.invalid' | cxTranslate }}
          </span>
          <span
            class="text-error"
            *ngIf="
              !editForm.get('email').value && editForm.get('email').touched
            ">
            {{ 'form.errors.required' | cxTranslate }}
          </span>
          <section class="">
            <label for="phoneNo" class="edit-labels edit-email">{{
              'form.fields.phone' | cxTranslate
            }}</label>
          </section>
          <section class="c-text-input">
            <input
              class="form-control contact-Field input-Field-Styling"
              formControlName="phoneNo"
              type="text"
              maxlength="12"
              [ngClass]="{
                requiredField:
                  editForm.get('phoneNo').invalid &&
                  (editForm.get('phoneNo').touched ||
                    editForm.get('phoneNo').dirty),
              }" />
          </section>
          <span
            class="text-error"
            *ngIf="
              editForm.get('phoneNo').invalid &&
              (editForm.get('phoneNo').dirty ||
                editForm.get('phoneNo').touched) &&
              editForm.get('phoneNo').value
            ">
            {{ 'form.errors.invalid' | cxTranslate }}
          </span>
          <span
            class="text-error"
            *ngIf="
              !editForm.get('phoneNo').value && editForm.get('phoneNo').touched
            ">
            {{ 'form.errors.required' | cxTranslate }}
          </span>

          <section
            class="d-inline-flex mt-2 justify-content-between col-12 p-0">
            <button (click)="onCancel()" class="c-button c-button--secondary">
              {{ 'common.cancel' | cxTranslate }}
            </button>
            <button (click)="onSave()" class="c-button c-button--primary">
              {{ 'common.save' | cxTranslate }}
            </button>
          </section>
        </section>
        <!--form end-->
      </section>
    </section>

    <section class="col-12 col-lg-9">
      <div *ngIf="selectedRequest$ | async as selectedRequest">
        <div class="w-100">
          <button
            (click)="viewOrderDetails(selectedRequest.guid)"
            class="ml-auto c-button c-button--secondary mb-3">
            {{ 'flu.dashboard.view-details' | cxTranslate }}
          </button>
        </div>
        <div class="d-flex justify-content-center mb-3">
          <canvas
            class="col-4"
            baseChart
            [data]="chartData"
            [options]="barChartOptions"
            type="pie">
          </canvas>
          <table class="col-8 c-table c-table--branded m-auto">
            <thead>
              <tr>
                <th>
                  {{ 'flu.dashboard.order-details-table.status' | cxTranslate }}
                </th>
                <th>
                  {{
                    'flu.dashboard.order-details-table.product' | cxTranslate
                  }}
                </th>
                <th>
                  {{
                    'flu.dashboard.order-details-table.quantity' | cxTranslate
                  }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let entry of selectedRequest.unconsignedEntries">
                <td>
                  {{ entry.quantityStatus }}
                </td>
                <td>{{ entry?.product.name }}</td>
                <td>{{ entry?.quantity }}</td>
              </tr>
              <tr *ngFor="let entry of selectedRequest.consignments">
                <td>
                  {{ entry.quantityStatus }}
                </td>
                <td>{{ entry?.product.name }}</td>
                <td>{{ entry?.quantity }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <section class="col-lg-12 col-xl-12 footer-Container">
        <app-influenza-dashboard-footer></app-influenza-dashboard-footer>
      </section>
      <app-influenza-dashboard-reservation-table></app-influenza-dashboard-reservation-table>
    </section>
  </section>
</section>
